module.exports = __webpack_public_path__ + "static/media/schnee.a29babc2.jpg";